import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/vehicleService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import { getAll } from "../../services/visaService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import queryString from "query-string";

class VehicleEditForm extends Form {
  state = {
    expiry_duration_options: [
      { id: "", name: "Select option" },
      { id: "monthly", name: "Monthly" },
      { id: "monthly-installment", name: "Monthly Installment" },
      { id: "yearly", name: "Yearly" },
    ],
    expiryDate: new Date(),
    data: {
      visa_id: "",
      name: "",
      mobile: "",
      ref_name: "",
      ref_mobile: "",
      cost: "",
      plat_number: "",
      expiry_duration_options: "",
    },
    visas: [],
    errors: {},
  };

  schema = {
    id: Joi.string(),
    plat_number: Joi.string().required().label("Plate Number"),
    visa_id: Joi.number().allow("").label("Visa Account"),
    name: Joi.string().allow().label("Name"),
    ref_name: Joi.string().label("Reference name"),
    ref_mobile: Joi.string().label("Reference mobile"),
    mobile: Joi.string().allow().label("Mobile"),
    cost: Joi.number().required().label("Cost"),
    expiry_duration_options: Joi.string().required().label("Expiry duration"),
    emirates_id: Joi.allow().label("Emirates Id"),
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(account) });

      const dateData = this.mapingData(account);

      this.setState({
        expiryDate: new Date(dateData.expiryDate),
      });

      const { data: visasAccounts } = await getAll();
      const visas = [{ id: "", name: "Select" }, ...visasAccounts];
      this.setState({ visas });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  mapingData(account) {
    return {
      expiryDate: account.expiry_date,
    };
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  mapToViewModel(account) {
    return {
      visa_id: account.visa === null ? "" : account.visa.id,
      name: account.name ? account.name : "",
      mobile: account.mobile ? account.mobile : "",
      cost: account.cost,
      ref_name: account.ref_name,
      ref_mobile: account.ref_mobile,
      plat_number: account.plat_number,
      expiry_duration_options: account.expiry_duration,
      emirates_id: account.emirates_id,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(ledgerTypeId);
      this.setState({ blocking: true });

      let event = new Date(this.state.expiryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);

      data.expiry_date = date;

      await updateSingle(data);
      this.setState({ blocking: false });
      toast.success("Account has been updated successfully.");
      this.props.history.push("/vehicles-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.visa_id)
          errors.visa_id = ex.response.data.errors.visa_id;

        if (ex.response.data.errors.plat_number)
          errors.plat_number = ex.response.data.errors.plat_number;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.cost)
          errors.cost = ex.response.data.errors.cost;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/vehicles.png";
    const { keyword, status } = queryString.parse(this.props.location.search);

    // if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add vehicle account</h1>
        <Link
          to={`/vehicles-accounts?keyword=${keyword}&status=${status}`}
          className="btn btn--secondary"
          style={{ marginBottom: "1rem", display: "inline-block" }}
        >
          Back
        </Link>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add vehicle account</h3>
              <p>Provide the information below to add the account.</p>
              {this.renderInput("plat_number", "Plate Number", "text")}
              {this.renderSelect(
                "visa_id",
                "Select visa account (optional)",
                this.state.visas
              )}
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("mobile", "Mobile", "text")}
              {this.renderInput("ref_name", "Reference Name", "text")}
              {this.renderInput("ref_mobile", "Reference Mobile", "text")}
              {this.renderInput("cost", "Cost", "text")}
              {this.renderSelect(
                "expiry_duration_options",
                "Renewal Duration",
                this.state.expiry_duration_options
              )}
              <label> Renewal Date </label>
              <DatePicker
                selected={this.state.expiryDate}
                onChange={this.handleChangeExpiry}
                className="input"
              />
              {this.renderInput("emirates_id", "Emirates Id", "text")}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default VehicleEditForm;
